export default "__VITE_ASSET__UH2GdsfI__"